/**
 * Assessment module — runtime API / asset base URLs.
 * Uses the current browser host (window.location) so LAN IP changes work without editing .env.
 */

const CI4_PATH = (process.env.REACT_APP_CI4_PATH || '/ci4-api').replace(/\/$/, '');

const isPrivateOrLocalHost = (hostname) => {
  if (!hostname) return false;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return true;
  if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  if (/^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(hostname)) return true;
  return false;
};

const trimTrailingSlash = (url) => String(url || '').replace(/\/$/, '');

/**
 * Optional override when React runs on localhost:3000 but XAMPP is on a LAN IP.
 * Set REACT_APP_API_HOST=192.168.x.x in Ticket/.env
 */
const getOverrideHost = () => {
  const override = (process.env.REACT_APP_API_HOST || '').trim();
  return override || null;
};

/**
 * @returns {string} e.g. http://192.168.140.155/ci4-api/api
 */
export function resolveAssessmentApiBaseUrl() {
  const envDev = (process.env.REACT_APP_API_BASE_URL_DEV || '').trim();
  const hasIndexPhp = envDev.toLowerCase().includes('/index.php');
  const apiSuffix = hasIndexPhp ? '/index.php/api' : '/api';

  if (typeof window !== 'undefined' && window.location?.hostname) {
    const { protocol, hostname } = window.location;
    if (isPrivateOrLocalHost(hostname)) {
      // CI4 API is on Apache (80/443), not the React dev server port (e.g. :3000).
      return `${protocol}//${hostname}${CI4_PATH}${apiSuffix}`;
    }
  }

  if (process.env.NODE_ENV === 'production') {
    const prod = (process.env.REACT_APP_API_BASE_URL_PROD || '').trim();
    if (prod) {
      return trimTrailingSlash(prod);
    }
  }

  const overrideHost = getOverrideHost();
  if (overrideHost) {
    const protocol =
      typeof window !== 'undefined' && window.location?.protocol
        ? window.location.protocol
        : 'http:';
    return `${protocol}//${overrideHost}${CI4_PATH}${apiSuffix}`;
  }

  if (envDev) {
    return trimTrailingSlash(envDev);
  }

  const host =
    typeof window !== 'undefined' ? window.location.hostname : 'localhost';
  const protocol =
    typeof window !== 'undefined' ? window.location.protocol : 'http:';
  return `${protocol}//${host}${CI4_PATH}${apiSuffix}`;
}

/**
 * @returns {string} e.g. http://192.168.140.155/ci4-api
 */
export function resolveAssessmentImageBaseUrl() {
  const envImage = (process.env.REACT_APP_IMAGEURL || '').trim();
  if (process.env.NODE_ENV === 'production' && envImage) {
    return trimTrailingSlash(envImage);
  }

  const apiBase = resolveAssessmentApiBaseUrl();
  return apiBase.replace(/\/(index\.php\/)?api$/i, '');
}
